import { defineMessages } from 'react-intl';

export default defineMessages({
  addTranslation: 'Add translation',
  connectExistingSurvey: 'Connect existing survey',
  connectQuestion: 'Connect existing question',
  connectOption: 'Connect existing option',
  connectOptionNoQuestion: 'Question not connected',
  connectOptionNoOptions: 'Question has no options, create them first',
  removeConnection: 'Remove connection',
  disconnect: 'Remove survey from group',
  confirmDisconnect: 'Do you really want to remove {title} from the group?',
});
